import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { RankingFilterOption } from '../models/ranking-filter-models';
import { GroupDetail, UserGroup } from '../models/group-models';

/**
 * Events of the prediction groups region: the user's groups, join/create/leave and the
 * opened group's ranking (with its own server-driven filter options).
 *
 * The filter-option events carry the `groupId` so the follow-up ranking load can never
 * be attributed to a group the user has meanwhile navigated away from.
 */
export const groupsEvents = eventGroup({
  source: 'Groups',
  events: {
    loadUserGroups: type<void>(),
    loadUserGroupsSuccess: type<{ groups: UserGroup[] }>(),
    loadUserGroupsFailed: type<{ error: string }>(),
    joinGroup: type<{ code: string }>(),
    joinGroupSuccess: type<{ group: UserGroup }>(),
    joinGroupFailed: type<{ error: string }>(),
    createGroup: type<{ name: string }>(),
    createGroupSuccess: type<{ group: UserGroup }>(),
    createGroupFailed: type<{ error: string }>(),
    leaveGroup: type<{ groupId: string }>(),
    leaveGroupSuccess: type<{ groupId: string }>(),
    leaveGroupFailed: type<{ error: string }>(),
    loadGroupRankingFilterOptions: type<{ groupId: string }>(),
    loadGroupRankingFilterOptionsSuccess: type<{ groupId: string; options: RankingFilterOption[] }>(),
    loadGroupRankingFilterOptionsFailed: type<{ groupId: string; error: string }>(),
    /** Picks the option whose group ranking is shown; the store loads that ranking in turn. */
    selectGroupFilterOption: type<{ option: RankingFilterOption }>(),
    loadGroupDetail: type<{ groupId: string; filterOption: RankingFilterOption }>(),
    loadGroupDetailSuccess: type<{ groupId: string; detail: GroupDetail }>(),
    loadGroupDetailFailed: type<{ groupId: string; error: string }>(),
    deselectGroup: type<void>(),
  },
});
